import styled from 'styled-components';
import { colours } from 'themes/default';
import Icons from 'components/ui/Icons/icons';
import { CtaButton } from '../AfterSalesCtas.styles';

export const StyledButtonMenuContainer = styled.div`
  dispaly: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-height: ${({ isMenuOpen }) => (isMenuOpen ? '300px' : '0')};
  opacity: ${({ isMenuOpen }) => (isMenuOpen ? '0.9' : '0')};
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  border: ${({ isMenuOpen }) => (isMenuOpen ? `solid 2px ${colours.Core.CoreNavy}` : 'none')};
  border-top: none;
  border-bottom-left-radius: ${({ isMenuOpen }) => (isMenuOpen ? '4px' : '0')};
  border-bottom-right-radius: ${({ isMenuOpen }) => (isMenuOpen ? '4px' : '0')};
`;

export const StyledUpgradeButtonContainer = styled.div`
  display: block;
  width: 100%;
  justify-content: center;
  align-items: center;
  positon: relative;
  border: solid 2px ${({ isDisabled }) => (isDisabled ? colours.Greyscale.MistGrey : colours.Core.CoreNavy)};
  border-top-left-radius: ${({ isMenuOpen }) => (isMenuOpen ? '4px' : '0')};
  border-top-right-radius: ${({ isMenuOpen }) => (isMenuOpen ? '4px' : '0')};
  transition: all 0.5s ease-in-out;
  background: ${({ isDisabled }) => (isDisabled ? colours.Greyscale.MistGrey : colours.Greyscale.White)};

  & hover {
    opacity: 1;
  }

  ${CtaButton}:disabled &,
  ${CtaButton}[disabled] & {
    border-color: ${colours.Greyscale.MistGrey};
    background: ${colours.Greyscale.MistGrey};
  }
`;

export const StyledUpgradeButtonText = styled.span`
  color: ${({ isDisabled }) => (isDisabled ? colours.Greyscale.CharcoalGrey : colours.Core.CoreNavy)};

  ${CtaButton}:disabled &,
  ${CtaButton}[disabled] & {
    color: ${colours.Greyscale.CharcoalGrey};
  }
`;

export const StyledIcon = styled(Icons.ChevronSmallRight)`
  position: absolute;
  width: 12px;
  height: 12px;
  top: 10px;
  right: 16px;
  transform: ${({ isMenuOpen }) => (isMenuOpen ? 'rotate(90deg)' : 'none')};
  transition: transform 0.5s ease-in-out;

  & > g > path {
    fill: ${({ isDisabled }) => (isDisabled ? colours.Greyscale.CharcoalGrey : colours.Core.CoreNavy)};
  }

  ${CtaButton}:disabled & > g > path,
  ${CtaButton}[disabled] & > g > path {
    fill: ${colours.Greyscale.CharcoalGrey};
  }
`;
